import { ALIAS_TYPE, ALIAS_DISPLAY_NAME } from './aliasConstants';
import { registerElementType } from '../elements/elementRegistry';
import elementConstructor from '../elements/elementConstructor';

const objectConstructorFn = (params) => ({
    ...elementConstructor(params),
    elementType: ALIAS_TYPE,
});

export default (params = {}) =>
    registerElementType({
        elementType: ALIAS_TYPE,
        objectConstructorFn,
        displayName: ALIAS_DISPLAY_NAME,
        ...params,
    });
